export const dateMixins = {
  data() {
    return {
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    }
  },
  methods: {
    getDateArticle(value) {
      const date = new Date(value)
      const getDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
      const month = date.getMonth() < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1

      return `${date.getFullYear()}-${month}-${getDate}`
    },

    getDateStringFormat(value) {
      const date = new Date(value)

      return `${date.getDate()} ${this.$t(
        `Month.${[this.month[date.getMonth()]]}`,
      )} ${date.getFullYear()}`
    },
  },
}
